import React from 'react';
import moment from 'moment-timezone';
import { Flex } from 'rebass';
import { FiClock, FiGlobe } from 'react-icons/fi';

import useIsMobile from 'hooks/useIsMobile';
import { DATE_STYLES, getMomentFormat } from 'utils/dateFormats';

const SchedulingPageNiceDateTime = props => {
    const isMobile = useIsMobile(520);

    return (
        <Flex style={{ flexDirection: 'column', gap: '12px' }}>
            <Flex style={{ alignItems: 'center', gap: isMobile ? '6px' : '8px' }}>
                <h3 className="fs-title-16 color-text-primary" style={{ margin: 0 }}>
                    {moment
                        .utc(props.spot)
                        .tz(props.timezone)
                        .format(getMomentFormat(DATE_STYLES.HUMAN_WEEKDAY_DATE_TIME))}
                </h3>
                <div className="horizontal-line color-bg-text-muted" />
                <FiClock className="icon-16 color-text-secondary" role="img" aria-label="duration" />
                <div className="fs-accent-16 color-text-primary" style={{ marginBottom: '1px' }}>
                    {props.duration} {isMobile ? 'min.' : 'minutes'}
                </div>
            </Flex>
            <Flex style={{ alignItems: 'center', gap: '8px' }}>
                <FiGlobe className="icon-16 color-text-primary" role="img" aria-label="timezone" />
                <div className="fs-accent-14 color-text-primary">{`${props.timezone} (${moment
                    .tz(props.timezone)
                    .zoneName()})`}</div>
            </Flex>
        </Flex>
    );
};

export default SchedulingPageNiceDateTime;
